import { render } from "./SelfieInstruction1.vue?vue&type=template&id=7ec96492"
import script from "./SelfieInstruction1.vue?vue&type=script&lang=js"
export * from "./SelfieInstruction1.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__